import React, { useCallback } from 'react';
import { useMainStackNavigation } from 'utils/types/navigationV6';
import { useStockMeta } from '../hooks/selectors';
import { SecclAssetSummaryCard } from './StockSummaryCard';
const SmartSecclAssetSummaryCard = ({ assetId }) => {
    const { navigateDeprecated } = useMainStackNavigation();
    const stock = useStockMeta(assetId);
    const onPress = useCallback(() => {
        navigateDeprecated('InvestStock', { assetId });
    }, [assetId]);
    if (!stock)
        return null;
    return <SecclAssetSummaryCard onPress={onPress} name={stock.name} iconUrl={stock.iconUrl}/>;
};
export default React.memo(SmartSecclAssetSummaryCard);
